import React from 'react';
import { Redirect } from 'react-router-dom';
import useAccountUrl from './useAccountUrl';

const AccountRedirect = ({ to }) => {
  const newTo = useAccountUrl({ to });

  return <Redirect to={newTo} />;
};

export default AccountRedirect;
